import { getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { getDatabase } from "firebase/database";
import { AES } from 'crypto-js';
import CryptoJS from 'crypto-js';

const parseFirebaseConfig = (configValue) => {
  try {
    return JSON.parse(configValue);
  } catch (error) {
    return Function('"use strict"; return (' + configValue + ')')();
  }
};


const initializeFirebase = (projectInfo) => {

  const CREDENTIALS_ENCRYPTION_KEY = 'B^(C4p*9Wj#Nf4dHsg9T';

  const configKey = projectInfo?.projectConfig?.config?.WEBSITE_FIREBASE_JSON_FILE;

  try {
    const decryptedValue = AES.decrypt(configKey, CREDENTIALS_ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
    const decryptedConfig = parseFirebaseConfig(decryptedValue);

    const firebaseConfig = {
      apiKey: decryptedConfig.apiKey,
      authDomain: decryptedConfig.authDomain,
      databaseURL: decryptedConfig.databaseURL,
      projectId: decryptedConfig.projectId,
      storageBucket: decryptedConfig.storageBucket,
      messagingSenderId: decryptedConfig.messagingSenderId,
      appId: decryptedConfig.appId,
      measurementId: decryptedConfig.measurementId
      
    };
    const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
    return getDatabase(app);
  } catch (error) {
    console.error("Decryption Error:", error);
    return null;
  }

};

export const initializeFirebaseAnalytics = async (projectInfo, userId) => {
  const pubid = Number(projectInfo?.projectConfig?.pubid);
  const configKey = projectInfo?.projectConfig?.config?.WEBSITE_FIREBASE_JSON_FILE;

  if (pubid !== 50106 || !configKey || typeof window === 'undefined') {
    return null;
  }

  const CREDENTIALS_ENCRYPTION_KEY = 'B^(C4p*9Wj#Nf4dHsg9T';

  try {
    const decryptedValue = AES.decrypt(configKey, CREDENTIALS_ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
    const decryptedConfig = parseFirebaseConfig(decryptedValue);

    if (!decryptedConfig.measurementId) {
      return null;
    }

    const supported = await isSupported();
    if (!supported) {
      return null;
    }

    const firebaseConfig = {
      apiKey: decryptedConfig.apiKey,
      authDomain: decryptedConfig.authDomain,
      databaseURL: decryptedConfig.databaseURL,
      projectId: decryptedConfig.projectId,
      storageBucket: decryptedConfig.storageBucket,
      messagingSenderId: decryptedConfig.messagingSenderId,
      appId: decryptedConfig.appId,
      measurementId: decryptedConfig.measurementId
    };

    const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);

    if (userId) {
      setUserId(analytics, String(userId));
    }

    setUserProperties(analytics, {
      pubid: String(projectInfo?.projectConfig?.pubid || ''),
      channelid: String(projectInfo?.projectConfig?.channelid || ''),
      country_code: projectInfo?.geoInfo?.countryCode || '',
      country: projectInfo?.geoInfo?.country || '',
      region: projectInfo?.geoInfo?.regionName || '',
      city: projectInfo?.geoInfo?.city || '',
      device_type: 'web'
    });

    logEvent(analytics, 'streamit_firebase_loaded', {
      pubid: String(projectInfo?.projectConfig?.pubid || ''),
      channelid: String(projectInfo?.projectConfig?.channelid || ''),
      has_user: !!userId
    });

    return analytics;
  } catch (error) {
    console.error('Firebase Analytics Error:', error);
    return null;
  }
};

export default initializeFirebase;
